import api from '../api'
import { apiV2 } from '../api-new'
import { httpRequest } from '../http-request'
import {
  BannerHeaderResponse,
  BannerCategoryResponse,
  MenusResponse,
} from './dtos'

export const getMenus = async () => {
  const response = await httpRequest<MenusResponse>({
    instance: apiV2,
    endpoint: '/canais/menus',
    method: 'POST',
    data: {
      slugs: [
        'menu-rodape-institucional',
        'menu-rodape-duvidas',
        'menu-topo-categorias',
        'menu-topo-categoria-principal',
      ],
    },
  })
  return response.data
}

export const getBannerHeader = async () => {
  const response = await httpRequest<BannerHeaderResponse>({
    instance: api,
    endpoint: '/canais/banners-areas/toten-header',
  })
  return response.data
}

export const getBannerCategory = async (category: string) => {
  const response = await httpRequest<BannerCategoryResponse>({
    instance: api,
    endpoint: `/canais/banners-categorias/${category}`,
  })
  return response.data
}
